import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=city&instance=${instance}`
    }
    
    return [{
        instance: instance,
        pageLayout: 'tabs_small',
        pageTitle: '赋能服务-饭协业协',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        icons: [
            {
                name: '白皮书',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/白皮书'),
                path: "赋能服务-饭协业协/白皮书",
            },
            {
                name: '联合调查',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件v2025-2/赋能生态/联合调查'),
                path: "赋能服务-饭协业协/联合调查",
            },
            {
                name: 'dataWANG',
                img: '/icons/时间线.svg',
                background: 'black',
                url: "https://datawang.com",
                external: true,
                path: "赋能服务-饭协业协/dataWANG",
            },
        ]
    }]
}